export const CONSTANTS = {
  BID_STATUS: {
    NO_STATUS: 0,
    NO_HIGHER_BID: 1,
    GOT_HIGHER_BID: 2,
    WON: 3,
    LOST: 4,
    // 0 - no
    // 1 - bided and still higher, green
    // 2 - bided and got higher bid, yellow
    // 3 - bided and sold out to me , red
    // 4 - bided and sold out to someone else , red
  },
  AUCTION_TYPES: {
    LIVE: "LIVE",
    TENDER: "TENDER",
    NEGOTIATION: "SUGGESTIONS",
  },
  OFFER_STATUS: {
    NO_STATUS: 0,
    OFFER_BY_USER: 1,
    ACCEPTED: 2,
    REJECTED: 3,
    OFFER_BY_ADMIN: 4,
    // 0 - no
    // 1 - offered by user
    // 2 - accepted
    // 3 - rejected
    // 4 - offer by admin
  },
  GET_TAX_PRICE: (value) => {
    {
      let tax = 0;
  
      if (value >= 1 && value <= 500000) {
        tax = 145000;
      } else if (value >= 500001 && value <= 1100000) {
        tax = 155000;
      } else if (value >= 1100001 && value <= 1600000) {
        tax = 175000;
      } else if (value >= 1600001 && value <= 2100000) {
        tax = 195000;
      } else if (value >= 2100001 && value <= 2600000) {
        tax = 220000;
      } else if (value >= 2600001 && value <= 3100000) {
        tax = 260000;
      } else if (value >= 3100001 && value <= 3600000) {
        tax = 300000;
      } else if (value >= 3600001 && value <= 4100000) {
        tax = 340000;
      } else if (value >= 4100001 && value <= 4600000) {
        tax = 380000;
      } else if (value >= 4600001 && value <= 5100000) {
        tax = 430000;
      } else if (value >= 5100001 && value <= 6100000) {
        tax = 490000;
      } else if (value >= 6100001 && value <= 8000000) {
        tax = 530000;
      } else if (value >= 8000001 && value <= 10000000) {
        tax = 630000;
      } else if (value >= 10000001 && value <= 15000000) {
        tax = 880000;
      } else {
        tax = 880000;
      }
  
      return tax;
    };
  }
};
